import { formatDateStringToObject } from 'syf-js-utilities';
var formatDate = function (inputDateString) {
    var inputDate = formatDateStringToObject(inputDateString);
    var day = inputDate.getDate().toString().padStart(2, '0');
    var month = (inputDate.getMonth() + 1).toString().padStart(2, '0'); // Note: Months are zero-based, so we add 1.
    var year = inputDate.getFullYear();
    return "".concat(month, "/").concat(day, "/").concat(year);
};
export default formatDate;
